import React, { Component } from 'react';
import { Grid, Col, Row } from 'react-bootstrap';

import Card from 'components/Card/Card.jsx';
import { Authenticator } from 'services/AuthService.jsx';
import Button from 'elements/CustomButton/CustomButton.jsx';
import { DataAPI } from 'services/DataService.jsx';
import moment from 'moment-timezone';

import { EventBus, EVENT_TYPE } from 'services/EventService.jsx'
import SweetAlert from 'react-bootstrap-sweetalert';

import Log from 'services/Log.jsx'



class ProjectSettings extends Component{

  constructor(props){
    super(props);
    this.state = {
      selected_project : {
        owner: {},
        plan: {}
      },
      alert: null,
      showAlert: false
    };
    this.hideAlert = this.hideAlert.bind(this);
    this.deleteWithModal = this.deleteWithModal.bind(this);
  }
  componentDidMount(props) {
    Authenticator.getUser((user) => {
      Log.debug(user.selectedProject);
      if (!user.selectedProject.sandbox) {
        DataAPI.getPlan((response) => {
            Log.debug(JSON.stringify(response));
            if (response.success) {
              this.setState({selected_project: user.selectedProject, plans: response.data.plans[0]});
            }
        });
      } else {
        this.setState({selected_project: user.selectedProject});
      }
    });
  }
  deleteProject(callback) {
    Authenticator.deleteProject((response) => {
      if (response.success) {
        Authenticator.refreshUser((user) => {
            EventBus.emit(EVENT_TYPE.USER_DATA);
            callback(response);
        });
      } else {
        callback(response);
      }
    });
  }
  warningWithConfirmMessage(){
        this.setState({
            alert: (
                <SweetAlert
                    input
                    style={{display: "block"}}
                    title="Are you sure?"
                    onConfirm={(e) => this.deleteWithModal(e)}
                    onCancel={() => this.hideAlert()}
                    confirmBtnBsStyle="info"
                    confirmBtnCssClass="btn-fill"
                    cancelBtnCssClass="btn-fill"
                    cancelBtnBsStyle="danger"
                    confirmBtnText="Yes, delete it!"
                    cancelBtnText="Cancel"
                    showCancel
                >
                    You are deleting your project, this is an irreversible action!
                    Enter your project name <b>("{this.state.selected_project.name}")</b> to confirm the deletion.
                    This will also cancel your subscription for this project.
                </SweetAlert>
            )
        });
    }
    deleteWithModal(input){
      if (input === this.state.selected_project.name) {
        this.deleteProject((response) => {
          if (response.success) {
            this.setState({
                alert: (
                    <SweetAlert
                        success
                        style={{display: "block"}}
                        title="Deleted!"
                        onConfirm={() => this.props.history.push("/dashboard")}
                        onCancel={() => this.hideAlert()}
                        confirmBtnBsStyle="info"
                        confirmBtnCssClass="btn-fill"
                    >
                        Your project has been deleted.
                    </SweetAlert>
                )
            });
          } else {
            this.setState({
                alert: (
                    <SweetAlert
                        danger
                        style={{display: "block"}}
                        title="Error!"
                        onConfirm={() => this.hideAlert()}
                        onCancel={() => this.hideAlert()}
                        confirmBtnBsStyle="info"
                        confirmBtnCssClass="btn-fill"
                    >
                      {response.errors[0]}
                    </SweetAlert>
                )
            });
          }
        })
      } else {
        this.setState({
            alert: (
                <SweetAlert
                    danger
                    style={{display: "block"}}
                    title="Error!"
                    onConfirm={() => this.hideAlert()}
                    onCancel={() => this.hideAlert()}
                    confirmBtnBsStyle="info"
                    confirmBtnCssClass="btn-fill"
                >
                    The project name you entered is invalid.
                </SweetAlert>
            )
        });
      }
    }
    hideAlert(){
        this.setState({
            alert: null
        });
    }
    render(){
        return (
            <div className="main-content project-settings">
              {this.state.alert}
                <Grid fluid>
                <Row className={'row-eq-height'}>
                    <Col md={8}>
                      <Card
                        title={'Project Name: ' + this.state.selected_project.name}
                        category="To change your selected project pick from the top bar"
                        content={
                          <Row>
                            <Col md={12}>
                              <h4>
                                API Key: <span>{this.state.selected_project.apiKey}</span>
                              </h4>
                              <h5>
                                Secret: <span>{this.state.selected_project.secret}</span>
                              </h5>
                            </Col>
                          </Row>
                        }
                      />
                  </Col>
                  <Col md={4} className={"flex-col"}>
                    <Card
                      title="Owner"
                      flex
                      content={
                        <Row>
                          <Col md={12}>
                            <h4>
                              <span>{this.state.selected_project.owner.name}</span>
                            </h4>
                          </Col>
                        </Row>
                      }
                    />
                  </Col>
                </Row>
                <Row>
                    <Col md={8}>
                        <Card
                          title="Plan"
                          content={
                            <Row>
                              <Col md={12}>
                                <Row>
                                  <Col md={12}>
                                    <Row>
                                      <Col md={3}>Title:</Col>
                                      <Col md={9}>{this.state.selected_project.plan.title}</Col>
                                    </Row>
                                    <Row>
                                      <Col md={3}>Description:</Col>
                                      <Col md={9}>{this.state.selected_project.plan.description}</Col>
                                    </Row>
                                    <Row>
                                      <Col md={3}>Datapoints:</Col>
                                      <Col md={9}>{this.state.selected_project.plan.datapoints}/mo</Col>
                                    </Row>
                                    <Row>
                                      <Col md={3}>Data Tagging:</Col>
                                      <Col md={9}>{this.state.selected_project.plan.tagging ? 'yes' : 'no'}</Col>
                                    </Row>
                                    <Row>
                                      <Col md={3}>Data Resolution:</Col>
                                      <Col md={9}>{this.state.selected_project.plan.resolution == 0 ? 'millisecond' : (this.state.selected_project.plan.resolution == 1 ? 'second' : 'minute')}</Col>
                                    </Row>
                                    <Row>
                                      <Col md={3}>Data Retention:</Col>
                                      <Col md={9}>{this.state.selected_project.plan.retention_label}</Col>
                                    </Row>
                                    <Row>
                                      <Col md={3}>Price:</Col>
                                      <Col md={9}>{this.state.selected_project.plan.price}$/mo</Col>
                                    </Row>
                                    <Row>
                                      <Col md={3}>Paid:</Col>
                                      <Col md={9}>{this.state.selected_project.plan.anual ? 'annually' : 'monthly'}</Col>
                                    </Row>
                                    {
                                      <Row>
                                        <Col md={3}>Created:</Col>
                                        <Col md={9}>{moment(new Date(this.state.selected_project.createdAt)).format("MMM Do YYYY")}</Col>
                                      </Row>
                                    }
                                  </Col>
                                </Row>
                                <Row className={'project-settings-controls'}>
                                  <Col md={9}></Col>
                                  <Col md={3}>
                                    <Button bsStyle="danger" fill wd onClick={this.warningWithConfirmMessage.bind(this)}>Delete Project</Button>
                                  </Col>
                                </Row>
                              </Col>
                            </Row>
                          }
                      />
                  </Col>
                </Row>
              </Grid>
            </div>
        );
    }
}

export default ProjectSettings;



// WEBPACK FOOTER //
// ./src/views/ProjectSettings/ProjectSettings.jsx